import styled from 'styled-components';
export const Container = styled.option `
    
`;
//# sourceMappingURL=Option.styled.js.map